
export default {
  props: ['avantageCampusTexteGros3','avantageCampusTextePetit3','avantageCampusLogo3','texteCampusAvantage3']
}
